import { render, staticRenderFns } from "./SuccessfulReminder.vue?vue&type=template&id=b97c62ce&"
import script from "./SuccessfulReminder.vue?vue&type=script&lang=js&"
export * from "./SuccessfulReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports